var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ul", { staticClass: "user-menu d-lg-block d-none" }, [
    _c("li", { staticClass: "profile" }, [
      _c(
        "a",
        { attrs: { href: "#" } },
        [
          _vm.user
            ? _c("LetterAvatar", {
                staticClass: "profile-picture",
                attrs: { initials: _vm.user.initials() }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.user && _vm.user.role
            ? _c("span", [
                _vm._v(
                  _vm._s(_vm.user.lastname) + " " + _vm._s(_vm.user.firstname)
                ),
                _c("br"),
                _vm._v("\n      (" + _vm._s(_vm.user.role.libelle) + ")")
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "profile-menu" },
        [
          _vm._l(_vm.userProfileMenu, function(menu, index) {
            return _c("li", { key: index }, [
              _c(
                "a",
                { attrs: { href: menu.href } },
                [
                  menu.icon
                    ? _c("icon", { attrs: { name: menu.icon } })
                    : _vm._e(),
                  _vm._v(_vm._s(menu.label))
                ],
                1
              )
            ])
          }),
          _vm._v(" "),
          _c("li", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.logout($event)
                  }
                }
              },
              [
                _c("icon", { attrs: { name: "power_settings_new" } }),
                _vm._v("Logout")
              ],
              1
            )
          ])
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-22d9d887", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22d9d887","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/UserMenu.vue
// module id = h2Fh
// module chunks = 15